import { FC } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { makeTransformStyles } from '../../../styles';
import CardActionArea, {
  CardActionAreaProps,
} from '@material-ui/core/CardActionArea';

const styles = {
  root: {
    height: '100%',
    color: 'inherit',
    textDecoration: 'none',
    '&:hover .plan-image': makeTransformStyles('scale(1.1)'),
    '&:hover': {
      color: 'inherit',
      textDecoration: 'none',
    },
  },
};

export default withStyles(styles)(
  CardActionArea as FC<CardActionAreaProps<'a'>>,
);
